// Derive whether a subtask value represents a "completed" answer. Bare
// Boolean(value) was the previous approach, but it misclassifies several real
// shapes as complete:
//   - INPUT_FIELD / TEXTAREA whitespace-only string ("   ") → would unlock Submit
//   - REPEATABLE_INPUT serialized empty array ("[]" or "[\"\"]") → same
//   - Non-empty radios ("no") are correctly truthy and should stay completed
// Callers: useSubtaskActions.updateSubtaskValue + Detail/index.tsx's
// allSubtasksCompleted gate. Both must agree on the predicate.
export function isSubtaskValueComplete(value: string | boolean | null | undefined): boolean {
  if (typeof value === "boolean") return value;
  if (typeof value !== "string") return false;

  const trimmed = value.trim();
  if (trimmed === "") return false;

  // REPEATABLE_INPUT persists as a JSON-serialized array. An empty array, or
  // an array whose every element is empty/whitespace, must not count.
  if (trimmed.startsWith("[") && trimmed.endsWith("]")) {
    try {
      const parsed: unknown = JSON.parse(trimmed);
      if (Array.isArray(parsed)) {
        return parsed.some((item) => {
          if (typeof item === "string") return item.trim() !== "";
          if (typeof item === "boolean") return item;
          if (item == null) return false;
          return Boolean(item);
        });
      }
    } catch {
      // Not actually JSON — fall through to the trimmed-string check below.
    }
  }

  return true;
}
